import { escape } from 'lodash'

export interface MediaCaptionImage {
  caption?: string | null
  description?: string | null
  author_name?: string | null
  authorName?: string | null
  author_url?: string | null
  authorUrl?: string | null
  platform?: string | null
  platform_url?: string | null
  platformUrl?: string | null
}

function creditLabel(name: string, url?: string | null): string {
  const href = url?.trim()
  if (!href) return escape(name)

  try {
    const { protocol } = new URL(href)
    if (protocol !== 'http:' && protocol !== 'https:') return escape(name)
  } catch {
    return escape(name)
  }

  return `<a class="lightbox-image-caption" href="${escape(href)}">${escape(name)}</a>`
}

export function generateCaptionHtml(image: MediaCaptionImage): string {
  const content = [image.caption ?? '', image.description ?? ''].filter(Boolean).join('<br><br>')
  const author = (image.author_name ?? image.authorName)?.trim()
  const platform = image.platform?.trim()
  let credit = author ? `Photo by ${creditLabel(author, image.author_url ?? image.authorUrl)}` : ''

  // Other is a CMS category, not a source name that should appear in a credit.
  if (platform && platform.toLowerCase() !== 'other') {
    const source = creditLabel(platform, image.platform_url ?? image.platformUrl)
    credit += credit ? ` on ${source}` : `Photo on ${source}`
  }

  return `<div>${content}</div>` + (credit ? `<span> ${credit}</span>` : '')
}
